var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadFill = function SvgUploadFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C14.73 6 17.0025 7.9425 17.5125 10.53C19.4625 10.665 21 12.27 21 14.25C21 16.32 19.32 18 17.25 18H7.5C5.0175 18 3 15.9825 3 13.5C3 11.1825 4.755 9.27 7.0125 9.03C7.95 7.23 9.8325 6 12 6ZM8.46967 13.2803C8.17678 12.9874 8.17678 12.5126 8.46967 12.2197L11.4691 9.22027C11.4695 9.21987 11.4699 9.21947 11.4703 9.21907L12 8.68934L12.5299 9.21927C12.5302 9.21954 12.5305 9.2198 12.5307 9.22007L15.5303 12.2197C15.8232 12.5126 15.8232 12.9874 15.5303 13.2803C15.2374 13.5732 14.7626 13.5732 14.4697 13.2803L12.75 11.5607V15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.5858 16.5 11.25 16.1642 11.25 15.75V11.5607L9.53033 13.2803C9.23744 13.5732 8.76256 13.5732 8.46967 13.2803Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "upload-fill.542da7ad07277507d4f41bdb2661c2e8.svg";